import React from 'react';
import { ts } from 'src/utils/translate';
import { FloorMap } from './FloorMap';
import { WiringMap } from './WiringMap';
import { WifiMap } from './WifiMap';
import { LightingCalculation } from './LightingCalculation';

export const FloorSvgs = (props: any) => {
  const {
    wifiEnabled,
    wiringEnabled,
    cameraEnabled,
    floorMapsEnabled,
    lightingEnabled,
    tableFloor,
  } = props;

  return (
    <React.Fragment>
      <FloorMap
        wiringTextNeeded={
          wiringEnabled && Array.isArray(tableFloor.floorWiringSvgObjs)
        }
        enabled={floorMapsEnabled}
        floorMapObj={tableFloor.floorSvgObj}
      />

      {Array.isArray(tableFloor.floorWiringSvgObjs)
        ? tableFloor.floorWiringSvgObjs.map((floorWiringSvgObject: any) => (
            <WiringMap
              key={floorWiringSvgObject.wiringType}
              enabled={floorMapsEnabled && wiringEnabled}
              floorWiringSvgObject={floorWiringSvgObject}
              tableRooms={tableFloor.tableRooms}
            />
          ))
        : null}

      {tableFloor && tableFloor.floorCameraSvgObj && cameraEnabled ? (
        <div
          className="map-comp-root"
          data-camerafloorid={tableFloor.floorCameraSvgObj.floorId}
        >
          {cameraEnabled && (
            <h3 className="">{ts("camera_coverage", "Security Cameras")}</h3>
          )}
          <FloorMap
            enabled={floorMapsEnabled && cameraEnabled}
            floorMapObj={tableFloor.floorCameraSvgObj}
          />
        </div>
      ) : null}

      {Array.isArray(tableFloor.floorWifiSvgObjs)
        ? tableFloor.floorWifiSvgObjs.map((floorWifiSvgObject: any) => (
            <WifiMap
              key={floorWifiSvgObject.wifiType}
              enabled={floorMapsEnabled && wifiEnabled}
              floorWifiSvgObject={floorWifiSvgObject}
            />
          ))
        : null}

      {tableFloor.lightingCalc ? (
        <LightingCalculation
          enabled={lightingEnabled}
          lightingData={tableFloor.lightingCalc}
          baseSvg={tableFloor.floorSvgObj}
        />
      ) : null}
    </React.Fragment>
  );
};